<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <!-- <a @click="$router.go(-1)" class="headerButton"> -->
                <router-link :to="{ name: 'home' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
                <!-- </a> -->
            </div>
            <div class="pageTitle">Semua</div>
        </div>
        <div id="appCapsule" v-if="loading.content == false">
            <!-- Menu Produk Keuangan -->
            <div class="section inset mt-2">
                <div class="order-menu p-0 m-0">
                    <h3 style="font-weight: bold" class="mb-0">Keuangan</h3>
                    <span style="font-size: 13px">Fitur Layanan Keuangan</span>
                    <hr style="margin-top: 5px" />
                    <div class="menu">
                        <div class="item" style="flex: none">
                            <a
                                href="Javascript:;"
                                @click="
                                    selectOptionTransfer(
                                        'sendmoney.order',
                                        null
                                    )
                                "
                            >
                                <img
                                    :src="
                                        require('@/assets/icon_menu/kirim_uang.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Kirim Uang</span></strong
                                >
                            </a>
                        </div>
                        <div class="item" style="flex: none">
                            <a
                                href="Javascript:;"
                                @click="
                                    selectOptionTransfer(
                                        'sendmoney.order',
                                        'EWALLET'
                                    )
                                "
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        require('@/assets/icon_menu/top_up_ewallet.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>E-Wallet Bebas Nominal</span></strong
                                >
                            </a>
                        </div>
                        <div class="item" style="flex: none">
                            <a
                                href="Javascript:;"
                                @click="
                                    selectOptionTransfer(
                                        'sendmoney.order',
                                        'TRANSFER_VA'
                                    )
                                "
                            >
                                <img
                                    :src="
                                        require('@/assets/icon_menu/transfer_va.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Transfer VA</span></strong
                                >
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Menu Produk Pasti Cuan -->
            <!-- <div
                class="section inset mt-2"
                v-if="customer.id == 1 || customer.id == 86807"
            >
                <div class="order-menu p-0 m-0">
                    <h3 style="font-weight: bold" class="mb-0">#PastiCuan</h3>
                    <span style="font-size: 13px"
                        >Berbagai Produk Paket Data Spesial</span
                    >
                    <hr style="margin-top: 5px" />
                    <div class="menu">
                        <div class="item" style="flex: none">
                            <a
                                href="Javascript:;"
                                @click="
                                    selectPastiCuanCategory(
                                        'pasti-cuan.telkomsel.product'
                                    )
                                "
                            >
                                <img
                                    :src="require('@/assets/tsel.png')"
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Telkomsel</span></strong
                                >
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- Menu Produk Prabayar -->
            <div class="section inset mt-2">
                <div class="order-menu p-0 m-0">
                    <h3 style="font-weight: bold" class="mb-0">Isi Ulang</h3>
                    <span style="font-size: 13px"
                        >Dengan {{ VUE_ENV.VUE_APP_NAME }} isi ulang apapun jadi
                        mudah</span
                    >
                    <hr style="margin-top: 5px" />
                    <div
                        class="menu"
                        v-for="chunks in chunkCategoryPrabayar"
                        :key="chunks.index"
                    >
                        <div
                            class="item"
                            v-for="item in chunks"
                            :key="item.id"
                            style="flex: none"
                        >
                            <router-link
                                :to="{
                                    name: 'prabayar-with-prefix-product',
                                    params: {
                                        id: item.id,
                                        title: item.product_name,
                                        withPrefix: item.withPrefix,
                                    },
                                }"
                                v-if="item.withPrefix === 1"
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        item.icon
                                            ? VUE_ENV.VUE_APP_ASSET_URL +
                                              '/img/icon/' +
                                              item.icon
                                            : require('@/assets/Loader-2.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong
                                    :class="
                                        item.product_name == 'Loading...'
                                            ? 'loading-component'
                                            : ''
                                    "
                                    style="margin: 3px; font-size: 10px"
                                    ><span>{{
                                        item.product_name
                                    }}</span></strong
                                >
                            </router-link>

                            <router-link
                                :to="{
                                    name: 'prabayar-without-prefix-product',
                                    params: {
                                        id: item.id,
                                        title: item.product_name,
                                        withPrefix: item.withPrefix,
                                        styleProduct: item.style_product,
                                    },
                                }"
                                v-else
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        item.icon
                                            ? VUE_ENV.VUE_APP_ASSET_URL +
                                              '/img/icon/' +
                                              item.icon
                                            : require('@/assets/Loader-2.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong
                                    :class="
                                        item.product_name == 'Loading...'
                                            ? 'loading-component'
                                            : ''
                                    "
                                    style="margin: 3px; font-size: 10px"
                                    ><span>{{
                                        item.product_name
                                    }}</span></strong
                                >
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Menu Produk Pascabayar -->
            <div
                class="section inset mt-2"
                v-if="chunkCategoryPascabayar.length > 0"
            >
                <div class="order-menu p-0 m-0">
                    <h3 style="font-weight: bold" class="mb-0">
                        Bayar Tagihan
                    </h3>
                    <span style="font-size: 13px"
                        >Solusi semua pembayaran tagihan hanya di
                        {{ VUE_ENV.VUE_APP_NAME }}</span
                    >
                    <hr style="margin-top: 5px" />
                    <div
                        class="menu"
                        v-for="chunks in chunkCategoryPascabayar"
                        :key="chunks.index"
                    >
                        <div
                            class="item"
                            v-for="item in chunks"
                            :key="item.id"
                            style="flex: none"
                        >
                            <!-- <router-link :to="{name:'pascabayar', params:{id:item.id, title:item.product_name, category_data:item}}">
                                <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                                <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                            </router-link> -->
                            <router-link
                                :to="{
                                    name: 'pascabayar-product',
                                    params: {
                                        id: item.id,
                                        title: item.product_name,
                                        styleProduct: item.style_product,
                                    },
                                }"
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        item.icon
                                            ? VUE_ENV.VUE_APP_ASSET_URL +
                                              '/img/icon/' +
                                              item.icon
                                            : require('@/assets/Loader-2.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong
                                    :class="
                                        item.product_name == 'Loading...'
                                            ? 'loading-component'
                                            : ''
                                    "
                                    style="margin: 3px; font-size: 10px"
                                    ><span>{{
                                        item.product_name
                                    }}</span></strong
                                >
                            </router-link>
                            <!-- <router-link :to="{name:'pascabayar', params:{id:item.id, title:item.product_name}}">
                                <img :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon" alt="image" class="imaged" style="width:70%;">
                                <strong>{{ item.product_name }}</strong>
                            </router-link> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Information Verification -->
        <action-sheet
            ref="information_verification"
            :title="'Informasi'"
            :inset="false"
        >
            <div class="text-center">
                <img
                    :src="require('@/assets/verification_rejected.png')"
                    alt="Verifikasi dalam proses"
                    class="w-50"
                /><br />
            </div>
            <div class="text-center p-2">
                <h3 class="mb-0">Anda belum melengkapi data diri</h3>
                <p class="mb-0">Yuk, segera langkapi sekarang</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block"
                    @click="hideInformationVerification(true)"
                >
                    Lengkapi Data Diri
                </button>
                <button
                    class="btn btn-outline-primary btn-block"
                    @click="hideInformationVerification(false)"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        data: () => ({
            loading: {
                content: true,
            },
        }),
        computed: {
            ...mapState([
                'customer',
                'categoryPrabayar',
                'categoryPascabayar',
                'VUE_ENV',
            ]),
            ...mapState('orderPastiCuan', {
                pasticuan_category: state => state.category,
            }),
            chunkCategoryPrabayar() {
                return window._.chunk(
                    window._.toArray(this.categoryPrabayar),
                    4
                );
            },
            chunkCategoryPascabayar() {
                return window._.chunk(
                    window._.toArray(this.categoryPascabayar),
                    4
                );
            },
        },
        methods: {
            ...mapActions(['getCategoryPrabayar', 'getCategoryPascabayar']),
            showInformationVerification() {
                let element = this.$refs.information_verification.$el;
                window.$(element).modal('show');
            },
            hideInformationVerification(redirect) {
                let element = this.$refs.information_verification.$el;
                window.$(element).modal('hide');
                if (redirect) {
                    this.$router.push({ name: 'account.data-diri' });
                }
            },
            checkAccountVerification() {
                if (
                    this.customer.account_verified_data == null ||
                    this.customer.account_verified_data.status != 'APPROVED'
                ) {
                    return true;
                } else {
                    return false;
                }
            },
            selectOptionTransfer(routeName, propsMethod) {
                if (this.checkAccountVerification()) {
                    this.showInformationVerification();
                } else {
                    this.$router.push({
                        name: routeName,
                        params: { transfer_method_selected: propsMethod },
                    });
                }
            },
            selectPastiCuanCategory(routeName) {
                this.$router.push({
                    name: routeName,
                });
            },
        },
        mounted() {
            this.getCategoryPrabayar();
            this.getCategoryPascabayar()
                .then(() => {
                    this.loading.content = false;
                })
                .catch(() => {
                    this.loading.content = false;
                });
        },
    };
</script>
